export default "__VITE_ASSET__DDCLvyYy__"